import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { KPICard } from '../../components/ui/KPICard';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { Button } from '../../components/ui/Button';
import { Drawer } from '../../components/ui/Drawer';
import { FileTextIcon, UploadIcon, AlertTriangleIcon, DownloadIcon, EyeIcon, RefreshCwIcon } from 'lucide-react';
const documents = [{
  id: 'DOC-001',
  name: 'Business Registration Certificate',
  type: 'Legal',
  expiry: '2026-03-20',
  status: 'Expiring Soon',
  owner: 'James Lim'
}, {
  id: 'DOC-002',
  name: 'Halal Certification',
  type: 'Certification',
  expiry: '2026-08-15',
  status: 'Valid',
  owner: 'Quality Team'
}, {
  id: 'DOC-003',
  name: 'ISO 9001:2015',
  type: 'Certification',
  expiry: '2027-01-10',
  status: 'Valid',
  owner: 'Quality Team'
}, {
  id: 'DOC-004',
  name: 'Public Liability Insurance',
  type: 'Insurance',
  expiry: '2025-12-31',
  status: 'Expired',
  owner: 'Finance Team'
}, {
  id: 'DOC-005',
  name: 'Supplier Code of Conduct',
  type: 'Policy',
  expiry: 'N/A',
  status: 'Valid',
  owner: 'James Lim'
}];
export const DocumentsPage: React.FC = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1063">
      <PageHeader title="Documents & Attestations" description="Manage your compliance documents, certifications, and policies." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Documents'
    }]} primaryAction={<Button variant="primary" leftIcon={<UploadIcon className="w-4 h-4" data-id="element-1066" />} onClick={() => setIsUploadOpen(true)} data-id="element-1065">
            Upload Document
          </Button>} data-id="element-1064" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1067">
        <KPICard title="Total Documents" value="12" icon={<FileTextIcon className="w-5 h-5" data-id="element-1069" />} data-id="element-1068" />
        <KPICard title="Expiring Soon" value="1" icon={<AlertTriangleIcon className="w-5 h-5 text-status-warning" data-id="element-1071" />} trend="down" trendValue="Action required" data-id="element-1070" />
        <KPICard title="Missing / Expired" value="1" icon={<AlertTriangleIcon className="w-5 h-5 text-status-error" data-id="element-1073" />} data-id="element-1072" />
      </div>

      <Card data-id="element-1074">
        <div className="mb-4 flex justify-between items-center" data-id="element-1075">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-1076">
            Document Repository
          </h2>
        </div>
        <DataTable data={documents} columns={[{
        header: 'Document Name',
        accessorKey: 'name',
        cell: row => <span className="font-medium text-fpg-navy" data-id="element-1078">{row.name}</span>
      }, {
        header: 'Type',
        accessorKey: 'type'
      }, {
        header: 'Expiry Date',
        accessorKey: 'expiry'
      }, {
        header: 'Owner',
        accessorKey: 'owner'
      }, {
        header: 'Status',
        cell: row => <StatusPill status={row.status === 'Expiring Soon' ? 'warning' : row.status === 'Expired' ? 'error' : 'success'} data-id="element-1079" />
      }, {
        header: 'Actions',
        align: 'right',
        cell: () => <div className="flex justify-end gap-2" data-id="element-1080">
                  <Button variant="ghost" size="sm" leftIcon={<EyeIcon className="w-4 h-4" data-id="element-1082" />} data-id="element-1081">
                    View
                  </Button>
                  <Button variant="ghost" size="sm" leftIcon={<DownloadIcon className="w-4 h-4" data-id="element-1084" />} data-id="element-1083">
                    DL
                  </Button>
                  <Button variant="secondary" size="sm" leftIcon={<RefreshCwIcon className="w-4 h-4" data-id="element-1086" />} data-id="element-1085">
                    Replace
                  </Button>
                </div>
      }]} data-id="element-1077" />
      </Card>

      <Drawer isOpen={isUploadOpen} onClose={() => setIsUploadOpen(false)} title="Upload Document" footer={<>
            <Button variant="ghost" onClick={() => setIsUploadOpen(false)} data-id="element-1088">
              Cancel
            </Button>
            <Button variant="primary" data-id="element-1089">Upload</Button>
          </>} data-id="element-1087">
        <div className="space-y-4" data-id="element-1090">
          <div className="space-y-1" data-id="element-1091">
            <label className="text-sm font-medium text-text-primary" data-id="element-1092">
              Document Type
            </label>
            <select className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" data-id="element-1093">
              <option data-id="element-1094">Certification</option>
              <option data-id="element-1095">Insurance Policy</option>
              <option data-id="element-1096">Legal Document</option>
              <option data-id="element-1097">Other</option>
            </select>
          </div>
          <div className="space-y-1" data-id="element-1098">
            <label className="text-sm font-medium text-text-primary" data-id="element-1099">
              Document Name
            </label>
            <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" placeholder="e.g. ISO 27001 Certificate" data-id="element-1100" />
          </div>
          <div className="space-y-1" data-id="element-1101">
            <label className="text-sm font-medium text-text-primary" data-id="element-1102">
              Expiry Date (if applicable)
            </label>
            <input type="date" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" data-id="element-1103" />
          </div>
          <div className="mt-4 border-2 border-dashed border-border-strong rounded-fluent p-12 text-center bg-surface-secondary" data-id="element-1104">
            <UploadIcon className="w-8 h-8 text-text-tertiary mx-auto mb-2" data-id="element-1105" />
            <p className="text-text-secondary font-medium" data-id="element-1106">
              Drag and drop file here
            </p>
            <p className="text-xs text-text-tertiary mt-1" data-id="element-1107">
              PDF, JPG, PNG up to 10MB
            </p>
            <Button variant="secondary" size="sm" className="mt-4" data-id="element-1108">
              Browse Files
            </Button>
          </div>
        </div>
      </Drawer>
    </div>;
};